import ServiceTemplate from '@/components/ServiceTemplate';

export default function CopyrightLegal() {
  const data = {
    title: 'Copyright Legal Services',
    subtitle: 'Comprehensive copyright legal services including licensing, enforcement, and litigation.',
    overviewTitle: 'Maximizing Your Copyright Value',
    overviewImage: 'https://images.unsplash.com/photo-1758518729794-456bbd9f70f8',
    description: [
      'Copyright legal services encompass all aspects of protecting and monetizing creative works beyond initial registration. These services include licensing agreements, enforcement actions, and litigation representation.',
      'Our experienced copyright attorneys help creators and rights holders maximize the value of their works through strategic licensing, effective enforcement, and skilled litigation when necessary.',
      'We provide comprehensive legal support to protect your creative investments and generate revenue from your copyrighted works.'
    ],
    benefits: [
      { title: 'Licensing Agreements', description: 'Draft and negotiate copyright licenses.' },
      { title: 'Rights Management', description: 'Manage and protect copyright portfolio.' },
      { title: 'Enforcement', description: 'Take action against infringement.' },
      { title: 'Litigation', description: 'Experienced copyright litigation representation.' },
      { title: 'Monetization', description: 'Generate revenue from your works.' },
      { title: 'Strategic Advice', description: 'Copyright strategy and portfolio management.' }
    ],
    process: [
      { title: 'Case Evaluation & Evidence', description: 'Comprehensive analysis of infringement and collection of supporting evidence.' },
      { title: 'Strategic Action & Negotiation', description: 'Enforcement action implementation and settlement negotiations with infringers.' },
      { title: 'Resolution & Protection', description: 'Securing favorable outcome and implementing ongoing protection measures.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Single work registration',
        price: '$199',
        period: '+ filing fees ($45-$65)',
        features: [
          'Single work registration',
          'Copyright Office filing',
          'Application preparation',
          'Certificate delivery',
          'Email support',
          'Standard processing'
        ]
      },
      {
        name: 'Professional',
        description: 'Multi-work package',
        price: '$399',
        period: '+ filing fees',
        featured: true,
        features: [
          'Up to 5 works registration',
          'Expedited filing available',
          'Comprehensive documentation',
          'Priority processing',
          'Copyright monitoring (6 months)',
          'Phone support',
          'Enforcement consultation'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Portfolio management',
        price: '$799',
        period: '+ filing fees',
        features: [
          'Unlimited registrations',
          'Portfolio strategy planning',
          'Ongoing monitoring',
          'DMCA takedown services',
          'Infringement detection',
          'Legal representation',
          'Dedicated account manager'
        ]
      }
    ],
    faqs: [
      { question: 'What is a copyright license?', answer: 'A license grants permission to use copyrighted work under specified terms, allowing monetization while retaining ownership.' },
      { question: 'What are exclusive vs non-exclusive licenses?', answer: 'Exclusive licenses grant rights to one licensee only; non-exclusive allow multiple licensees to use the work simultaneously.' },
      { question: 'How are licensing fees determined?', answer: 'Fees depend on work type, use scope, duration, exclusivity, territory, and market standards for similar works.' },
      { question: 'Can I license internationally?', answer: 'Yes, copyright protection exists internationally through treaties. Licenses can grant rights worldwide or in specific territories.' },
      { question: 'What is work-for-hire?', answer: 'Works created by employees or under certain written agreements belong to the employer/commissioner, not the creator.' },
      { question: 'How do I transfer copyright ownership?', answer: 'Copyright transfers require written agreements specifically conveying rights. Without writing, rights remain with creator.' },
      { question: 'What about digital rights management?', answer: 'DRM technologies control how digital works are used. We advise on DRM implementation and enforcement under DMCA anti-circumvention provisions.' },
      { question: 'When should I litigate?', answer: 'Consider litigation for significant infringement where damages justify costs, settlement negotiations fail, or to establish important legal precedents.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
